import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { Status } from './general.model';
import { Time } from '@angular/common';
import { LookUp } from 'src/app/front-user/shared/models/look-up.model';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';

export class SupplierDTO {
    UserId: string;
    SupplierTypeId: number;
    SupplierNatureId: number;
    IsLocalSupplier: boolean;
    CompanyName: string;
    CommercialName: string;
    CommercialRecordNumber: string;
    CommercialRecordExpiryDate: Date;
    IndustrialRegistrationNumber: string;
    TaxRecordNumber: string;
    // TaxCardNumber: string;
    TaxCardExpiryDate: Date;
    TaxAuthority: string;
    VATRegistrationDate: Date;
    VATNumber: string;
    ActivityLegalRecordRegistrationNumber: string;
    ActivityLegalRecordRegistrationDate: Date;
    PaidCapital: string;
    CompanyEstablishingDate?: Date;
    AverageAnnualTurnover: string;
    AverageAnnualTurnoverCurrencyId?: number;
    ConstructionNumber: string;
    ContractorCategoryId?: number;
    ContractorClassificationId?: number;
    Address: string;
    PostalCode: string;
    ContactPersonName: string;
    Phone: string;
    Fax: string;
    ContactPersonEmail: string;
    GovernorateId: number;
    WebSiteURL: string;
    MaintenanceCenterAddress: string;
    MaintenanceContactPerson: string;
    MaintenancePhone: string;
    MaintenanceFax: string;
    AccountStatusId?: number;
    DisableReason: string;
    // LookUps
    SupplierNature: LookUp;
    Governorate: LookUp;
    SupplierType: LookUp;
    Currency: LookUp;
    ContractorCategory: LookUp;
    ContractorClassification: LookUp;
    SupplierAccountStatus: LookUp;
    // Reapeted
    SupplierBanks: SupplierBankDTO[];
    SupplierSpecialities: SupplierSpecialityDTO[];
    DeletedSupplierSpecialities: SupplierSpecialityDTO[] = new Array();
    SupplierPartnerships: SupplierPartnershipDTO[] = new Array<SupplierPartnershipDTO>();
    // Attachments
    SupplierAttachments: Attachment[];
    SupplierCertificates: SupplierCertificateDTO[];
    IsAdminEditMode: Boolean;
}
export class SupplierBankDTO {
    UserId: string;
    BankName: string;
    BankBranch: string;
    AccountNumber: string;
    BankId?: number;
}
export class CategoryDTO {
    Id: number;
    NameEN: string;
    NameAR: string;
    Code: string;
}
export class SupplierPartnershipDTO {
    Id: string;
    PartnerName: string;
    NationalityId: number;
    RegisterationDate: Date;
    SupplierId: string;
    PartnerWebsiteURL: string;
    SupplierCommercialAgencyCopyURL: string;
    SupplierCommercialAgencyCopyName: string;
    SupplierPartnershipCategories: SupplierPartnershipCategoryDTO[] = new Array<SupplierPartnershipCategoryDTO>();
}
export class SupplierPartnershipCategoryDTO {
    Id: number;
    SupplierPartnershipId: string;
    CategoryId: number;
}

export class SupplierCertificateDTO {
    Id: string;
    DocumentName: string;
    URL: string;
    SupplierId: string;
    IsDeleted: boolean;
    CertificateType: number;
    CertificateTypeOther: string;
}
export class ETenderDTO {
    Id: string;
    Language: number;
    TenderTypeId: number;
    TitleAR: string;
    TitleEN: string;
    Date: Date;
    Time: Date;
    BookletPrice: string;
    InsuranceValue: string;
    SessionPlaceAR: string;
    SessionPlaceEN: string;
    GeneralTermsAR: string;
    GeneralTermsEN: string;
    TenderNumber: string;
    FileNumber: string;
    FinancialYear: Date;
    OfferDeadline: Date;
    ODTime?: Date;
    OD?: Date;
    PrimaryInsuranceValue: string;
    TenderMethodId: string;
    HaveMaintenanceContract?: boolean;
    MaintenanceContractValue: string;
    AcceptRetail?: boolean;
    HaveAlternativeOffers?: boolean;
    EvaluationSystemId?: number;
    MinimumAcceptancePointsForTechnicalOffer?: number;
    Comments: string;
    ClarificationDurationStartDate?: Date;
    CDStartDateTime?: Date;
    CDStartDate?: Date;
    ClarificationDurationEndDate?: Date;
    CDEndDateTime?: Date;
    CDEndDate?: Date;
    PublishingDate?: Date;
    PDTime?: Date;
    PD?: Date;
    CommentsAr: string;
    CommentsEn: string;
    ETenderManagerId: number;
    ETenderSuppliers: ETenderSupplierDTO[];
    Suppliers: SupplierDTO[];
    Specialities: Speciality[];
    ETendersAttachments: ETendersAttachmentDTO[];
    ETendersCategoriesAdmin: ETendersCategoriesAdminDTO[];
    ETendersCategories: CategoryDTO[];
    TechnicalAdmins: ETendersCategoriesAdminDTO[];
    PurchasingAdmins: ETendersCategoriesAdminDTO[];
    CreatedBy: string;
    CreationDate: Date;
    ETenderCreatorId: number;
    CancellationReason: string;
    Status: number;
    IsNotoficationSent: boolean;
    DefineOfferDeadlineComments: string;
}

export class ETenderViewAllFieldsDTO {
    Id: string;
    TenderTypeId: number;
    TenderType: string;
    TitleAR: string;
    TitleEN: string;
    SessionPlaceAR: string;
    SessionPlaceEN: string;
    TenderNumber: string;
    FileNumber: string;
    FinancialYear: string;
    OfferDeadline: string;
    OfferDeadlineTime: string;
    PrimaryInsuranceValue: string;
    TenderMethod: string;
    HaveMaintenanceContract?: boolean;
    MaintenanceContractValue: string;
    AcceptRetail?: boolean;
    HaveAlternativeOffers?: boolean;
    EvaluationSystem: string;
    MinimumAcceptancePointsForTechnicalOffer?: number;
    CommentsAR: string;
    CommentsEN: string;
    ClarificationDurationStartDate: string;
    ClarificationDurationStartTime: string;
    ClarificationDurationEndDate: string;
    ClarificationDurationEndTime: string;
    PublishingDate: string;
    PublishingTime: string;
    BookletCopy: string;
    CancellationCopy: string;
    ETendersCategories: string;
    CancellationReason: string;
    ShowClarification: boolean;
}
export class ETenderViewAllFieldsAdminDTO {
    Id: string;
    TenderTypeId: number;
    TenderType: string;
    TitleAR: string;
    TitleEN: string;
    SessionPlaceAR: string;
    SessionPlaceEN: string;
    TenderNumber: string;
    FileNumber: string;
    FinancialYear: string;
    OfferDeadline: string;
    OfferDeadlineTime: string;
    PrimaryInsuranceValue: string;
    TenderMethod: string;
    HaveMaintenanceContract?: boolean;
    MaintenanceContractValue: string;
    AcceptRetail?: boolean;
    HaveAlternativeOffers?: boolean;
    EvaluationSystem: string;
    MinimumAcceptancePointsForTechnicalOffer?: number;
    CommentsAR: string;
    CommentsEN: string;
    ClarificationDurationStartDate: string;
    ClarificationDurationStartTime: string;
    ClarificationDurationEndDate: string;
    ClarificationDurationEndTime: string;
    PublishingDate: string;
    PublishingTime: string;
    BookletCopy: string;
    CancellationCopy: string;
    ETendersCategories: string;
    CancellationReason: string;
    ShowClarification: boolean;
    ETenderSuppliers: ETenderSupplierDTO[];
}

export class DefineTenderOfferDeadlineDTO {
    Id: string;
    Language: number;
    TitleAR: string;
    TitleEN: string;
    ClarificationDurationEndDate: Date;
    OfferDeadline: Date;
    ODTime?: Date;
    OD?: Date;
    ETenderSuppliers: ETenderSupplierDTO[];
    DefineOfferDeadlineComments: string;
    ETendersAttachments: ETendersAttachmentDTO[];
}

export class ETenderViewDTO {
    Id: string;
    TenderTypeId: number;
    Title: string;
    Date?: Date;
    Time?: Date;
    TenderType: string;
    BookletPrice: string;
    InsuranceValue: string;
    SessionPlace: string;
    GeneralTerms: string;
    BookletCopy: string;
}

export class ETenderEvaluationSystemDTO {
    Id: number;
    NameEN: string;
    NameAR: string;
    ETenders: ETenderDTO[];
}
export class ETenderSupplierDTO {
    Id: number;
    ETenderId: string;
    SupplierId?: string;
    IsSupplierInvolved?: boolean;
    IsMoreThanOneOffer?: boolean;
    IsQualified?: boolean;
    IsHighPrice?: boolean;
    IsWinner?: boolean;
    QualificationComment: string;
    PricingComment: string;
    ETender: ETenderDTO;
    Supplier: SupplierDTO;

}
export class ETendersAttachmentDTO {
    Id: string;
    URL: string;
    ETenderId: number;
    DocumentName: string;
    AttachmentTypeId: number;
    AttachmentType: ETenderAttachmentType;
}
export class ETendersCategoriesAdminDTO {
    Id: string;
    ETenderId?: number;
    CategoryId: number;
    Category: CategoryDTO;
    SPGroupUserId?: number;
    SPGroupUserName: string;
    SPGroupUser: SPGroupUserDTO;
}
export class SupplierSpecialityDTO {
    Id: number;
    CategoryId: number;
    SpecialityId: number;
    SupplierId: string;
    ContactPerson: string;
    Email: string;
    Fax: string;
    Mobile: string;
    Address: string;
    ExperienceCopyURL: string;
    ExperienceCopyName: string;
    Speciality: Speciality;
    Supplier: SupplierDTO;
    ETenderSuppliers: ETenderSupplierDTO;
    PurchasingAdminRejectionReason: string;
    TechnicalAdminRejectionReason: string;
    Status: number;
    IsDeleted: boolean;
}
export class Speciality {
    Id: number;
    NameEN: string;
    NameAR: string;
    CategoryId: number;
    SupplierSpecialities: SupplierSpecialityDTO[];
}
export class SPGroupUserDTO {
    Id: number;
    Username: string;
    SPGroupId: number;
    Email: string;
    CategoryId: number;
}
export enum EtenderLanguages {
    Arabic = 1,
    English = 2,
    Both = 3
}

export enum ETenderAttachmentType {
    Booklet = 1,
    CancellationAttachment = 2,
    DefineOfferDeadlineAttachment = 3,
}

export enum ETenderStatus {
    Published = 1,
    Canceled = 2,
    Deleted = 3,
    Closed = 4,
    UnderStudying = 5,
    Created = 6
}

export enum ETenderTypes {
    PublicTender = 2,
    LimitedTender = 3,
    Quotations = 4,
    Practice = 5,
    PublicBidding = 6
}

export enum ETenderMethods {
    SingleEnvelope = 1,
    TwoEnvelopes = 2
}

export enum SupplierCertificateTypes {
    "ISO14001" = 1,
    "LEED" = 2,
    "FSC" = 3,
    "Other Certificates" = 4,
}

export class SupplierRegistrationLookups {
    SupplierNatures: LookUp[];
    SupplierTypes: LookUp[];
    ContractorCategories: LookUp[];
    ContractorClassifications: LookUp[];
    Specialities: Speciality[];
    SupplierAccountStatuses: LookUp[];
    Currencies: LookUp[];
    Governorates: LookUp[];
    Categories: LookUp[];
    Nationalities: LookUp[];
    Banks: Bank[];
}
export class ETenderSupplierEvaluation {
    Id: number;
    ETenderId: string;
    SupplierId: string;
    IsSupplierInvolved: boolean;
    IsMoreThanOneOffer: boolean;
    IsQualified: boolean;
    IsHighPrice: boolean;
    IsWinner: boolean;
    QualificationComment: string;
    PricingComment: string;
    Supplier: SupplierDTO;
    ETender: ETenderDTO;

}
export class SupplierDTOForRAting {
    SupplierSpecialitiesNames: SupplierSpecialitiesName[];
}

export class SupplierSpecialitiesName {
    Id: number;
    SpecialityCategoryName: string;
    SpecialityName: string;
    Rating: number;
}

export class SupplierRegistrationApprovalDecisionDTO {
    WFAppInstanceID: string;
    SupplierId: string;
    AdminEmail: string;
    AprovalDecision: number;
    RejectionReason: string;
    RejectionMail: boolean;
}

export class SupplierRegistrationActivationDTO {
    WFAppInstanceID: string;
    SupplierId: string;
    AdminEmail: string;
}
export enum ETenderAdminTypes {
    SCAServices_ETenderManagers = 16,
    SCAServices_ETenderCreators = 17,
    SCAServices_ETenderTechnicalCategoryAdmins = 18,
    SCAServices_ETenderPurchasingCategoryAdmins = 19,
    SCAServices_ETenderPurchasingDivisionManager = 20,
    SCAServices_ETenderTechnicalDivisionManagers = 40,
    SCAServices_ETender_MessagingAdmins = 41,
    SCAServices_RegistrationAdmin = 14,
    SCAServices_FiberglassAdmin = 2,
    SCAServices_FloatingAdmin = 3,
    SCAServices_QualityAdmin = 4,
    SCAServices_RepairAdmin = 5,
    SCAServices_SalvageAdmin = 6,
    SCAServices_ShipyardAdmin = 7,
    SCAServices_LHManagementandReportsOnly = 52,
    SCAServices_MarineNavigationOfficer = 9,
    SCAServices_MarineNavigationOfficer_Suez = 54,
    SCAServices_MeasurementDepartmentManager = 10,
    SCAServices_MeasurementDepartmentManager_Suez = 55,
    SCAServices_MeasurementOfficer = 11,
    SCAServices_MeasurementOfficer_Suez = 53,
    SCAServices_MeasurementsOfficerReviewer = 12,
    SCAServices_TreasuryOfficer = 15,
    SCAServices_MeasurementCommittee = 1,
    SCAServices_EconomicCommittee = 8,
    SCAServices_LongHaulFormulatedDecision = 42,
    SCAServices_MeasurementSuez = 43,
    SCAServices_MeasurementPortSaid = 44,

    SCAServices_EBooking_MessagingAdmins = 30,
    SCAServices_FeesEstimation_MessagingAdmins = 35,
    SCAServices_UpdateAgentProfile_MessagingAdmins = 36,
    SCAServices_TransitRequest_MessagingAdmins = 37,
    SCAServices_AgentReg_MessagingAdmins = 23,

    SCAServices_SmallUnits_smallunitsPS = 56,
    SCAServices_SmallUnits_smallunitsPT = 57,
    SCAServices_SmallUnits_smallunitsIS = 58,
    SCAServices_SmallUnits_FinancePS = 59,
    SCAServices_SmallUnits_MessagingAdmins = 60,
    SCAServices_SmallUnits_FinancePT = 61,

    SCAServices_circulars_measurement_first = 62,
    SCAServices_circulars_measurement_second = 63,
    SCAServices_circulars_measurement_third = 64,
    SCAServices_circulars_Reports = 65,
    SCAServices_circulars_MessagingAdmins = 66,
    SCAServices_SmallUnits_ISMMarine = 67,

    SCAServices_CrewChange_Reviewer = 69,
    SCAServices_CrewChange_Approval = 70,

    SCAServices_RefundFirstReviewer = 72,
    SCAServices_RefundSecondReviewer = 73,
    SCAServices_RefundMeasurementManager = 74,
    SCAServices_RefundEunitGroup = 75,
    SCAServices_RefundDeputyManager = 76,
    SCAServices_RefundManager = 77,
    SCAServices_RefundMeasurementPrint = 78,
    SCAServices_RestudyReviewer = 79,
    SCAServices_RestudyManager = 80,
    SCAServices_RestudyEconomic = 81,
    SCAServices_RestudyEconomicApprove = 82,
    SCAServices_ReleaseFormCreator = 83,
    SCAServices_ReleaseReports = 84,

    SCAServices_NavigationOfficer = 85
}

export class Bank {
    Id: number;
    NameEN: string;
    NameAR: string;
    MaxNumber1?: number;
    MaxNumber2?: number;
}

